'use strict';

import './liquid.directive.scss';

export default angular
  .module('maestro.directives.components.liquid', [])
  .directive('liquid', () => {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        class: '@'
      },
      controller: ($scope, $element, $attrs) => {
        
      },
      template: function(tElement, tAttrs) {
        return `<div class="liquid-container"><div class="liquid"></div></div>`;
      }
    };
  })
  .name;
